export const FormStatus = {
  idle: 'idle',
  submitting: 'submitting',
  succeeded: 'succeeded',
  failed: 'failed',
};